var _ = require('underscore');
var Backbone = require('backbone');
var Marionette = require('marionette');
var Labels = EY.Consultation.Labels;
var StatusType = EY.Consultation.Lookups.StatusType;

var View = Marionette.View.extend({
    className: function () {
        return !this.model.get('show') ? 'hidden' : 'col-lg-1 col-md-1 col-sm-12 col-xs-12 badge ' + this.model.get('className') + ' badge-connect visible-lg visible-md';
    },
    template: '#recordStage'
});

var CollectionView = Marionette.CollectionView.extend({
    childView: View,
    className: 'row badge-pill hidden-print hidden-xs hidden-sm'
});

var stages = function (options) {    
    var approvers = options.approvers.groupBy('approverGroupId');
    var groups = options.groups;
    var record = options.record;
    var completed = record.get('statusTypeId') === StatusType.Complete || record.get('statusTypeId') === StatusType.UsersNotified;
    var order = record.get('statusTypeId') === StatusType.ReviewApproval ? groups.get(record.get('approverGroupId')).get('order') : -1;
    var submitted = completed || record.get('statusTypeId') === StatusType.ReviewApproval;
    var collection = new Backbone.Collection(_.map(groups.models, function (group) {
        if (group.get('visible')) {
            var className = completed ? 'badge-complete' : 'badge-default';
            if (group.get('order') <= order) {
                var approved = _.every(approvers[group.id],
                    function (approver) {
                        return approver.get('approval');
                    });
                className = approved ? 'badge-complete' : 'badge-inprogress visible-sm visible-xs small-badge-pill';
            }
            return {
                className: className,
                show: group.get('required') || (_.first(approvers[group.id]).get('upn') && !group.get('approvalNotRequired')) ? true : false, //TODO --SQ not elagent, need to be elavated to configuration by introducting a sepearate configuration flag!!!
                stage: Labels['ApproverGroup_' + group.id + '_Stage']
            };
        }
    }));
    
    collection.unshift({
        className: submitted ? 'badge-complete' : 'badge-inprogress visible-sm visible-xs small-badge-pill',
        show: true,
        stage: Labels.Submission_Stage
    });

    return collection;
};

module.exports.start = function (options) {
    var region = options.region;

    region.show(new CollectionView({
        collection: stages(options)
    }));
};


// WEBPACK FOOTER //
// ./js/Modules/Record/UI/RecordStage.js